import { dm_loaisuckhoe } from "../../../models/response/category/dm_loaisuckhoe";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objLoaiSucKhoeDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as dm_loaisuckhoe[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as dm_loaisuckhoe | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as dm_loaisuckhoe,
    SAVE_SUCESS: {} as dm_loaisuckhoe,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eLoaiSucKhoeActionTypeIds = generateActionTypeIds(objLoaiSucKhoeDefine, "LOAI_SUC_KHOE")
export type ILoaiSucKhoeActionTypes = IGenericActionType<typeof objLoaiSucKhoeDefine, "LOAI_SUC_KHOE">
